import type { FaireProductEntity } from "../../entity_types/product";

export const p_xz4skkmrek: FaireProductEntity = {
  token: "p_xz4skkmrek",
  type: "product",
  name: "Major Monuments Espresso",
  brandToken: "b_3juit7iu0l",
  brandName: "Go Get Em Tiger",
  imageUrl: "https://cdn.faire.com/fastly/d1c6e1423b9b124dedc16ec547e753f51e7530b6da5b7896a1e7ad9a5b9d2910.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bf7694f9c087440ba0a2ac6e6187133a73920e546c9cb2eed1621d9697fb4542.jpeg",
    "https://cdn.faire.com/fastly/c94f8d89e0cfd10aeb2924d9c8bc8f33a7b0e83a5a89f31da25d4a4c216e9de7.jpeg"
  ],
  priceDollars: 27,
  description: "Major Monuments Espresso by Go Get Em Tiger is a testament to quality, expertise, and passion. Since 2013, we have been connecting people with the world's finest coffees. Our Major Monuments Espresso is no exception. We work closely with award-winning farmers globally to source the best beans. Each batch is roasted to perfection, preserving the unique character of the beans. Enjoy the exceptional taste that sets Go Get Em Tiger apart.",
  tags: [],
  msrpDollars: 54,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-12T22:02:13.125Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
